var map = {
	"./01.jpg": 308,
	"./02.jpg": 309,
	"./03.JPG": 310,
	"./04.jpg": 311,
	"./05.jpg": 312,
	"./125327233_10222831927082161_6440974222704808100_n.jpg": 313,
	"./Artie 4.jpg": 314,
	"./IMG_5285.JPG": 315,
	"./Jai Jemmi.JPG": 316,
	"./ShuiabMoosa 12.95kg 7th.jpg": 317,
	"./WhatsApp Image 2022-10-18 at 10.55.35 AM.jpeg": 318,
	"./WhatsApp Image 2022-10-18 at 11.39.04 AM.jpeg": 319,
	"./WhatsApp Image 2022-10-18 at 11.40.47 AM.jpeg": 320,
	"./WhatsApp Image 2022-10-18 at 9.38.44 AM.jpeg": 321,
	"./WhatsApp Image 2025-10-08 at 13.01.57_b2dbc33c.jpg": 322,
	"./kfc-24-4.jpg": 323,
	"./kfc-24-5.jpg": 324,
	"./kfc-24-9.jpg": 325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 307;